import { AccountInsulins } from "./AccountInsulins"
import { AccountMedications } from "./AccountMedications"
import styles from "./InsulinAndMedication.module.scss"
import {
  AccountInsulinModal,
  AccountMedicationModal,
  PageTemplate,
} from "src/components"
import {
  useFollowedUsers,
  usePolyglot,
} from "src/contexts"
import {
  AccountInsulinLoadingProvider,
  AccountMedicationLoadingProvider,
} from "src/contexts/LoadingContexts"

export function InsulinAndMedication() {
  const polyglot = usePolyglot()

  const {
    currentUserId,
    currentFollow,
  } = useFollowedUsers()

  return (
    <PageTemplate
      user="follow"
      title={polyglot.t("components.page_header.pages.insulin_and_medication")}
      backRoutePath={currentFollow.is_self ? "/settings" : "/settings/$accountId"}
      backRouteParams={currentFollow.is_self ? {} : { accountId: currentUserId }}
    >
      <div className={styles.container}>
        <AccountInsulinModal>
          <AccountInsulinLoadingProvider>
            <AccountInsulins />
          </AccountInsulinLoadingProvider>
        </AccountInsulinModal>
        <AccountMedicationModal>
          <AccountMedicationLoadingProvider>
            <AccountMedications />
          </AccountMedicationLoadingProvider>
        </AccountMedicationModal>
      </div>
    </PageTemplate>
  )
}
